import { render, staticRenderFns } from "./MessageListMessageInline.vue?vue&type=template&id=5fd3a9a0&scoped=true&functional=true&"
import script from "./MessageListMessageInline.vue?vue&type=script&lang=js&"
export * from "./MessageListMessageInline.vue?vue&type=script&lang=js&"
import style0 from "./MessageListMessageInline.vue?vue&type=style&index=0&id=5fd3a9a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5fd3a9a0",
  null
  
)

export default component.exports